
















































import { Component, Vue, Prop } from 'vue-property-decorator'
import * as utils from '@ivy/fts/utils'

@Component
export default class CourseCard extends Vue {
  @Prop({ default: false }) isHasRequire: boolean // 当前是否已经发起了请求
  @Prop({ default: false }) isOldNotAvailable: boolean // 老用户是否可领
  @Prop({ default: false }) isFirst: boolean // 是否是第一次领取
  @Prop() learninEnv: string // 课程时上课方式 'h5' 'app'
  phoneNumber: string
  smsCode: any = null
  geting: boolean = false
  countdownTimer: any = '重新获取 60s'
  canSend: boolean = false
  get getCodeText() {
    if (!this.geting) return '获取验证码'
    return this.countdownTimer
  }
  get btnText() {
    return this.isHasRequire &&
      (this.learninEnv === 'app' || this.isOldNotAvailable)
      ? '打开APP体验'
      : '立即学习'
  }

  async sendSmsCode() {
    if (!this.phoneNumber) {
      this.$Toast('请输入手机号')
      return
    }
    if (!/^1[3456789]\d{9}$/.test(this.phoneNumber)) {
      this.$Toast('手机号格式不正确')
      return
    }
    if (this.geting) return
    this.geting = true
    this.$emit('sendSmsCode', this.phoneNumber)
    for (let count = 60; count > 0; count--) {
      this.countdownTimer = `重新获取 ${count}s`
      await utils.sleep(1000)
    }
    this.geting = false
  }

  async freeGetHandelr() {
    await this.$emit('addStatistics', 'click_freeGet')
    if (!this.phoneNumber || !this.smsCode) {
      this.$Toast('请输入必要信息')
      return
    }
    await this.$emit('clickHandler', {
      type: 'freeGet',
      phoneNumber: this.phoneNumber,
      smsCode: this.smsCode,
    })
  }

  learnCourse() {
    if (
      this.isHasRequire &&
      !this.isOldNotAvailable &&
      this.learninEnv === 'h5'
    ) {
      this.$emit('learn_course')
    } else {
      this.$emit('clickHandler', {
        type: 'openApp',
      })
    }
  }
}
